import { render, staticRenderFns } from "./PhieuThuChuaXuLy.vue?vue&type=template&id=56503e30&"
import script from "./PhieuThuChuaXuLy.vue?vue&type=script&lang=js&"
export * from "./PhieuThuChuaXuLy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports